/**
 * Drag Select Plugin for uPlot (X-axis only)
 * Implements rectangle selection for zooming
 */

import uPlot from "uplot";

export function dragSelectPlugin() {
  return {
    hooks: {
      setSelect: [
        (u: uPlot) => {
          const sel = u.select;
          if (sel.width < 10) return; // ignore tiny/near-axis noise
          const newXMin = u.posToVal(sel.left, "x");
          const newXMax = u.posToVal(sel.left + sel.width, "x");
          u.setSelect({ left: 0, top: 0, width: 0, height: 0 }, false);
          setTimeout(() => {
            u.setScale("x", { min: newXMin, max: newXMax });
          }, 0);
        },
      ],
    },
  };
}
